export class RelatedLinkBase {
  public id?: number;
  public formID!: number;
  public text!: string;
  public url?: string;
  public date?: Date | null;
}

export class RelatedLinkBaseSave {
  public id?: number;
  public formID!: number;
  public text!: string;
  public url?: string;
  public date?: Date | null;
}

export class RelatedLinkBaseHandler {
  static toSave(relatedLinkBase: RelatedLinkBase): RelatedLinkBaseSave {
    var save = new RelatedLinkBaseSave();
    save.id = relatedLinkBase.id;
    save.formID = relatedLinkBase.formID;
    save.text = relatedLinkBase.text;
    save.url = relatedLinkBase.url;
    save.date = relatedLinkBase.date;
    return save;
  }
}
